module.exports = __webpack_public_path__ + "static/media/Pago aprobado.a9279b5a.svg";